module.exports = __webpack_public_path__ + "static/media/kumpan.f13f9469.png";